import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, LL_H_C, TS_Card } from '@nu-art/thunderstorm-frontend/index';
import { _keys, MUSTNeverHappenException } from '@nu-art/ts-common';
import './Component_HVValueMappingEditor.scss';
import { Component_SwitchView } from '@nu-art/permissions-frontend/ui/Component_SwitchView';
import { ModuleFE_Variable } from '../../../../../../_entity/variable/index.js';
import { DropDown_VariableV3 } from '../../../../../../_entity/variable/ui-components.js';
import { ModuleFE_Value } from '../../../../../../_entity.js';
import { DropDown_Value } from '../../../../../../_entity/value/ui-components.js';
import { filterRelevantValues } from '../../../../../healthcare-space/variables/components/Component_RelationsTable/utils/utils.js';
import { ICONS } from '@app/styles';
import { TS_EditableItemComponent } from '@nu-art/thunderstorm-frontend/editable-item';
import React from 'react';
import { resolveValueDisplay } from '@app/hcs-shared';
export class Component_HVValueMappingEditor extends TS_EditableItemComponent {
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        // update mode if needed
        state.mode = nextProps.mode;
        // index values for easier access
        state.usedVarIds = nextProps.usedVarIds;
        // return state
        return state;
    }
    renderVarSelector = (varId) => {
        return _jsx(Component_SwitchView, { mode: this.state.mode, modes: [
                {
                    key: 'view',
                    renderer: () => {
                        const variable = ModuleFE_Variable.cache.unique(varId);
                        if (!variable)
                            throw new MUSTNeverHappenException(`cannot find variable with id ${varId}`);
                        return _jsx("div", { children: variable.name });
                    }
                },
                {
                    key: 'edit',
                    renderer: () => {
                        return _jsx(DropDown_VariableV3.selectable, { selected: varId, limitItems: 50, queryFilter: _var => !this.state.usedVarIds.includes(_var._id), onSelected: async (_var) => {
                                if (_var._id === varId)
                                    return;
                                // Update dictionary
                                const item = { ...this.state.editable.item };
                                item[varId] = undefined;
                                item[_var._id] = [];
                                await this.state.editable.updateObj(item);
                            } });
                    }
                }
            ] });
    };
    renderValueSelector = (valIds, varId) => {
        // Harel commenting, 13.3.25: at the moment we'll allow selection of only one value due to UI support in the advisor
        // in the future we *want* to allow multiple values
        return _jsx(Component_SwitchView, { mode: this.state.mode, modes: [
                {
                    key: 'view',
                    renderer: () => {
                        const value = ModuleFE_Value.cache.unique(valIds[0]);
                        if (!value)
                            throw new MUSTNeverHappenException(`cannot find value with id ${valIds[0]}`);
                        return _jsx("div", { children: resolveValueDisplay(value) });
                    }
                },
                {
                    key: 'edit',
                    renderer: () => {
                        const variable = ModuleFE_Variable.cache.unique(varId);
                        const variableVal = ModuleFE_Value.cache.unique(variable?.valueId);
                        return _jsx(DropDown_Value.selectable, { selected: valIds[0], queryFilter: (val) => filterRelevantValues(variableVal).includes(val._id), onSelected: async (_val) => {
                                await this.state.editable.updateObj({
                                    ...this.state.editable.item,
                                    [varId]: [_val._id] // currently we support single value id only
                                });
                            } });
                    }
                }
            ] });
    };
    renderValueMappingItem(varId, valIds) {
        return _jsxs(React.Fragment, { children: [this.renderVarSelector(varId), this.renderValueSelector(valIds, varId), this.state.mode === 'edit' ? _jsx(ICONS.bin.component, { onClick: async () => {
                        const item = { ...this.state.editable.item };
                        item[varId] = undefined;
                        await this.state.editable.updateObj(item);
                    } }) : _jsx("div", {})] }, varId);
    }
    renderHeader = () => {
        return _jsxs(LL_H_C, { className: 'expression-builder-value-mapping__header', children: [_jsx("div", { children: "Findings Output" }), this.state.mode === 'edit' && _jsx(ICONS.advisor_v5_plus.component, { onClick: async () => {
                        await this.state.editable.updateObj({ ...this.state.editable.item, '': [] });
                    } })] });
    };
    render() {
        const valueMapping = this.state.editable.item;
        return _jsxs(TS_Card, { id: 'expression-builder-value-mapping', children: [this.renderHeader(), _jsx(Grid, { children: _keys(valueMapping).map(varId => this.renderValueMappingItem(varId, valueMapping[varId])) })] });
    }
}
//# sourceMappingURL=Component_HVValueMappingEditor.js.map